import { useTranslation } from 'react-i18next';

import {
  StyledContentWrapper,
  StyledFakeInput,
  StyledFakeInputLabel,
  StyledLine,
  StyledMessage,
  StyledMockupWrapper,
  StyledTextEllipsis,
} from './styled';

type EmailMockupProps = {
  email?: string;
  subject?: string;
  message?: string;
};

export const EmailMockup = ({ email, subject, message }: EmailMockupProps) => {
  const { t } = useTranslation();

  return (
    <StyledMockupWrapper>
      <StyledContentWrapper>
        <StyledFakeInputLabel>{t('other:address')}</StyledFakeInputLabel>
        <StyledFakeInput>
          <StyledTextEllipsis>{email}</StyledTextEllipsis>
        </StyledFakeInput>
        <StyledFakeInputLabel>{t('other:subject')}</StyledFakeInputLabel>
        <StyledFakeInput>
          <StyledTextEllipsis>{subject}</StyledTextEllipsis>
        </StyledFakeInput>
        <StyledFakeInputLabel>{t('other:message')}</StyledFakeInputLabel>
        <StyledLine />
        <StyledMessage>{message}</StyledMessage>
      </StyledContentWrapper>
    </StyledMockupWrapper>
  );
};
